<template>
  <input
    ref="cost"
    class="field-input__inner"
    autocomplete="new-password"
    :placeholder="placeholder"
    :disabled="disabled"
    type="text"
    inputmode="decimal"
    @input="onChangeCost"
    @blur="$emit('blur')"
  >
  <!--    <div-->
  <!--      v-if="showExportCost || exportCostForce"-->
  <!--      class="input-cost-custom__cost-currency"-->
  <!--    >-->
  <!--      {{ exportCost }} €-->
  <!--    </div>-->
</template>
<script>
/* global IMask */
import _ from 'lodash';
import { exportCost } from '../../../models/calculator-customs';
import { PACKAGE_TYPE } from '../../../helpers/constans';

export default {
  name: 'InputCostCustoms',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 6,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showExportCost: {
      default: false,
      type: Boolean,
    },
    exportCostForce: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    exportCost: '0.00',
    vMask: null,
  }),
  watch: {
    value(val) {
      if (this.exportCostForce || this.showExportCost) {
        this.vMask.value = val;
      }
      if (!this.showExportCost) return;
      if (val === '0') {
        this.exportCost = '0.00';
        this.$emit('export-cost', '0.00');
        return;
      }
      this.debouncedFetchExportCost(val);
    },
    exportCost(val) {
      this.$emit('export-cost', val);
    },
    exportCostForce: {
      handler(val) {
        if (val) {
          let cost = val;
          if (typeof cost === 'string') {
            cost = (+(cost.replace(/\s/g, ''))).toFixed(2);
          }
          this.exportCost = (val !== '0') ? cost : '0.00';
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init();
  },
  created() {
    this.PACKAGE_TYPE = PACKAGE_TYPE;
    if (this.showExportCost) {
      this.debouncedFetchExportCost = _.debounce(this.fetchExportCost, 1000);
    }
  },
  methods: {
    fetchExportCost(cost) {
      let price = cost;
      if (typeof cost === 'string') {
        price = cost.replace(/\s/g, '');
      }
      exportCost(price, '051')
        .then((total) => {
          if (this.value === '0') return;
          this.exportCost = total.toFixed(2);
        })
        .catch((errArr) => {
          this.$emit('error', errArr.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    init() {
      const costImask = {
        mask: Number,
        min: 0,
        thousandsSeparator: ' ',
        radix: '.',
        mapToRadix: [','],
      };

      this.vMask = IMask(this.$refs.cost, costImask);
    },
    onChangeCost(e) {
      const value = e.target.value.replace(',', '.').replaceAll(' ', '');
      if (value.includes('.')) {
        const fractional = value.split('.');
        if (fractional[1] && fractional[1].length > 2) return;
      }
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.price-input {
  text-align: left !important;
}
.input-cost-custom {
  display: flex;
  align-items: center;
  width: 100%;
  @media (max-width: 767px) {
    flex-direction: column;
  }
  & .field-input__inner {
    padding: 12px 24px;
    min-height: 60px;
    height: 60px;
    &:disabled {
      background-color: transparent;
    }
  }
}
.input-cost-custom__cost-currency {
  min-width: 74px;
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #9FB3C3;
  text-align: right;
  @media (max-width: 767px) {
    margin-top: 4px;
    align-self: flex-end;
    margin-right: 24px;
  }
}
.input-cost-custom__input-wrap {
  position: relative;
  width: 100%;
  input {
    padding-right: 41px !important;
  }
  .input-cost-custom__icon {
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #9FB3C3;
  }
}
</style>
